export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.chat.clikkle.com'; 
export const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.chat.clikkle.com';